import { persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';

import sellerPanelReducer from './seller-panel/seller-panel.slice';
import userMachineReducer from './userMachine/user-machine.slice';
import userJobReducer from './userJob/user-job.slice';
import { authReducer } from './auth/auth.slice';

const sellerPanelPersistConfig = {
  key: 'sellerPanel',
  storage: storageSession,
  whitelist: ['selectedStore'],
};

const rootReducer = {
  userJob: userJobReducer,
  userMachine: userMachineReducer,
  sellerPanel: persistReducer(sellerPanelPersistConfig, sellerPanelReducer),
  auth: authReducer,
};

export default rootReducer;
